import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styles from "./Translate.module.sass";
import Card from "../../../../../components/Card";
import cn from "classnames";
import Actions from "../../../../../components/Actions";
import { uploadVideoSentence } from "../../../../../api/texts.service";
import Modal from "../../../../../components/Modal";
import { toast } from "sonner";
import { LANG_LABELS } from "../../../../../utils/constants";

const LANGS = ["en", "es", "fr", "ru", "pt"];

const Translate = ({
  chapter,
  editarCapitulo,
  editarFraseDeCapitulo,
  anadirFraseACapitulo,
  anadirCardAFrase,
  editarTraduccionDeFrase,
  eliminarFraseDeCapitulo,
  eliminarCardDeFrase,
  chapterIndexSelected,
  handleGetContent,
  id,
  traducirTextoFrase,
  myRefs,
  translateRefs,
  videoRefs,
  layout = "combined", // "combined" | "split" | "header" | "video" | "translation"
  sentenceIndex,
  activeTitleTab: activeTitleTabProp,
  onActiveTitleTabChange,
}) => {
  const { t } = useTranslation();
  const [activeTitleTabInternal, setActiveTitleTabInternal] = useState("en");
  const activeTitleTab = activeTitleTabProp ?? activeTitleTabInternal;
  const setActiveTitleTab = onActiveTitleTabChange ?? setActiveTitleTabInternal;

  const [sentenceIndexSelected, setSentenceIndexSelected] = useState("");

  const [isModalUploadVideo, setIsModalUploadVideo] = useState(false);

  const [videoSrc, setVideoSrc] = useState(null);
  const [file, setFile] = useState("");

  const [loading, setLoading] = useState(false);

  const handleVideoChange = (e) => {
    const file = e.target.files[0];
    setFile(file);
    if (file) {
      const src = URL.createObjectURL(file);
      setVideoSrc(src);
    }
  };

  const handleUploadVideoSentence = async () => {
    setLoading(true);
    let body = new FormData();
    body.append("textId", id);
    body.append("chapter", chapterIndexSelected);
    body.append("sentence", sentenceIndexSelected);
    body.append("file", file);
    const result = await uploadVideoSentence(body);
    setLoading(false);
    if (result?.data === true) {
      toast.success(t("toast.uploadedSuccessfully"));
      setVideoSrc("");
      setFile("");
      setIsModalUploadVideo(false);
      //handlePutContent();
      handleGetContent();
    } else {
      toast.error(t("toast.errorUploadingVideo"));
    }
  };

  if (layout === "header") {
    return (
      <div className={styles.headerOnly}>
        <span className="title-blue">Translate</span>
      </div>
    );
  }

  if (layout === "video" && chapter?.sentences?.[sentenceIndex] !== undefined) {
    const c = chapter.sentences[sentenceIndex];
    const i = sentenceIndex;
    return (
      <div
        ref={(el) => { if (videoRefs) videoRefs.current[i] = el; }}
        className={styles.sentenceContainerVideo}
      >
        {c?.videoUrl ? (
          <div className={styles.videoWrapper}>
            <video controls src={c?.videoUrl} />
          </div>
        ) : (
          <div className={styles.videoPlaceholder} />
        )}
        <div
          className={cn(styles.statusBadge, c?.translations?.find((t) => t?.lang === activeTitleTab)?.active ? styles.verified : styles.notVerified)}
        >
          {c?.translations?.find((t) => t?.lang === activeTitleTab)?.active ? "Verified" : "Not Verified"}
        </div>
      </div>
    );
  }

  if (layout === "translation" && chapter?.sentences?.[sentenceIndex] !== undefined) {
    const c = chapter.sentences[sentenceIndex];
    const i = sentenceIndex;
    return (
      <>
        <Modal
          outerClassName={styles.outer}
          visible={isModalUploadVideo}
          onClose={() => setIsModalUploadVideo(false)}
          stylesCustom={{ maxWidth: 600 }}
        >
          <div>
            {videoSrc && <video src={videoSrc} controls width="500" />}
            {videoSrc ? (
              <button onClick={() => { setFile(""); setVideoSrc(""); }} className={cn("button-small", styles.deleteVideoBtn)}>Delete</button>
            ) : (
              <input type="file" accept="video/*" onChange={handleVideoChange} />
            )}
            <button disabled={!file || !videoSrc || loading} onClick={handleUploadVideoSentence} style={{ marginLeft: 20 }} className={cn("button-small", styles.button)}>
              {loading ? "Uploading..." : "Upload"}
            </button>
          </div>
        </Modal>
        <div
        ref={(el) => { if (translateRefs) translateRefs.current[i] = el; }}
        className={styles.sentenceContainer}
      >
        <div className={cn(styles.sentenceContent, styles.sentenceContentTranslationOnly)}>
          <textarea
            className={styles.sentenceTextarea}
            rows="4"
            value={c?.translations?.find((t) => t?.lang === activeTitleTab)?.trans || ""}
            onChange={(e) =>
              editarTraduccionDeFrase(chapterIndexSelected, i, activeTitleTab, {
                active: activeTitleTab === "en" ? true : false,
                lang: activeTitleTab,
                trans: e.target.value,
              })
            }
          />
        </div>
        <div
          className={cn(styles.statusBadge, c?.translations?.find((t) => t?.lang === activeTitleTab)?.active ? styles.verified : styles.notVerified)}
        >
          {c?.translations?.find((t) => t?.lang === activeTitleTab)?.active ? t("common.verified") : t("common.notVerified")}
        </div>
        <div className={styles.actionsBadge}>
          <Actions
            className={styles.actions}
            classActionsHead={styles.actionsHead}
            items={[
              {
                title: "Auto-translate",
                icon: "check",
                action: () =>
                  traducirTextoFrase(
                    chapterIndexSelected,
                    i,
                    c?.translations?.find((t) => t?.lang === "en")?.trans,
                    activeTitleTab
                  ),
              },
              {
                title: "Verify Trans",
                icon: "check-all",
                action: () =>
                  editarTraduccionDeFrase(chapterIndexSelected, i, activeTitleTab, {
                    active: true,
                    lang: activeTitleTab,
                    trans: c?.translations?.find((t) => t?.lang === activeTitleTab)?.trans,
                  }),
              },
              {
                title: "Upload Video",
                icon: "upload",
                action: () => {
                  setSentenceIndexSelected(i);
                  setIsModalUploadVideo(true);
                },
              },
              {
                title: <span style={{ opacity: c?.videoUrl ? 1 : 0.5 }}>Video</span>,
                icon: "download",
                action: () => { if (c?.videoUrl) console.log("tiene video"); },
              },
              {
                title: <span style={{ opacity: c?.audioUrl ? 1 : 0.5 }}>Audio</span>,
                icon: "download",
                action: () => { if (c?.audioUrl) console.log("tiene audio"); },
              },
              {
                title: "Delete",
                icon: "trash",
                action: () => eliminarFraseDeCapitulo(chapterIndexSelected, i),
              },
            ]}
            small
          />
        </div>
      </div>
      </>
    );
  }

  return (
    <>
      <Modal
        outerClassName={styles.outer}
        visible={isModalUploadVideo}
        onClose={() => setIsModalUploadVideo(false)}
        stylesCustom={{ maxWidth: 600 }}
      >
        <div>
          {videoSrc && <video src={videoSrc} controls width="500" />}
          {videoSrc ? (
            <button
              onClick={() => {
                setFile("");
                setVideoSrc("");
              }}
              className={cn("button-small", styles.deleteVideoBtn)}
            >
              Delete
            </button>
          ) : (
            <input type="file" accept="video/*" onChange={handleVideoChange} />
          )}
          <button
            disabled={!file || !videoSrc || loading}
            onClick={handleUploadVideoSentence}
            style={{ marginLeft: 20 }}
            className={cn("button-small", styles.button)}
          >
            {loading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </Modal>
      {layout === "split" ? (
        <>
          <div className={styles.colVideo}>
            <div className={styles.sentenceList}>
              {chapter?.sentences?.map((c, i) => (
                <div
                  key={c?.id || i}
                  ref={(el) => { if (videoRefs) videoRefs.current[i] = el; }}
                  className={styles.sentenceContainerVideo}
                >
                  {c?.videoUrl ? (
                    <div className={styles.videoWrapper}>
                      <video controls src={c?.videoUrl} />
                    </div>
                  ) : (
                    <div className={styles.videoPlaceholder} />
                  )}
                  <div
                    className={cn(styles.statusBadge, c?.translations?.find((t) => t?.lang === activeTitleTab)?.active ? styles.verified : styles.notVerified)}
                  >
                    {c?.translations?.find((t) => t?.lang === activeTitleTab)?.active ? "Verified" : "Not Verified"}
                  </div>
                </div>
              ))}
            </div>
          </div>
          <Card
            title="Translate"
            classTitle="title-blue"
            head={
              <div style={{ display: "flex", alignItems: "center" }} className={cn(styles.nav, "tablet-hide")}>
                {LANGS.map((x, index) => (
                  <button
                    className={cn(styles.link, styles.linkFlag, {
                      [styles.active]: x === activeTitleTab,
                    })}
                    onClick={() => setActiveTitleTab(x)}
                    key={index}
                    title={LANG_LABELS[x]}
                    aria-label={LANG_LABELS[x]}
                  >
                    <img src={`/images/flags/${x}.svg`} alt="" width={24} height={18} />
                  </button>
                ))}
              </div>
            }
          >
            <div style={{ minHeight: "65vh" }} className={styles.sentenceList}>
              {chapter?.sentences?.map((c, i) => (
                <div
                  key={c?.id || i}
                  ref={(el) => { if (translateRefs) translateRefs.current[i] = el; }}
                  className={styles.sentenceContainer}
                >
                  <div className={cn(styles.sentenceContent, styles.sentenceContentTranslationOnly)}>
                    <textarea
                      className={styles.sentenceTextarea}
                      rows="4"
                      value={c?.translations?.find((t) => t?.lang === activeTitleTab)?.trans || ""}
                      onChange={(e) =>
                        editarTraduccionDeFrase(chapterIndexSelected, i, activeTitleTab, {
                          active: activeTitleTab === "en" ? true : false,
                          lang: activeTitleTab,
                          trans: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div className={styles.actionsBadge}>
                    <Actions
                      className={styles.actions}
                      classActionsHead={styles.actionsHead}
                      items={[
                        {
                          title: "Auto-translate",
                          icon: "check",
                          action: () =>
                            traducirTextoFrase(
                              chapterIndexSelected,
                              i,
                              c?.translations?.find((t) => t?.lang === "en")?.trans,
                              activeTitleTab
                            ),
                        },
                        {
                          title: "Verify Trans",
                          icon: "check-all",
                          action: () =>
                            editarTraduccionDeFrase(chapterIndexSelected, i, activeTitleTab, {
                              active: true,
                              lang: activeTitleTab,
                              trans: c?.translations?.find((t) => t?.lang === activeTitleTab)?.trans,
                            }),
                        },
                        {
                          title: "Upload Video",
                          icon: "upload",
                          action: () => {
                            setSentenceIndexSelected(i);
                            setIsModalUploadVideo(true);
                          },
                        },
                        {
                          title: <span style={{ opacity: c?.videoUrl ? 1 : 0.5 }}>Video</span>,
                          icon: "download",
                          action: () => {
                            if (c?.videoUrl) {
                              console.log("tiene video");
                            }
                          },
                        },
                        {
                          title: <span style={{ opacity: c?.audioUrl ? 1 : 0.5 }}>Audio</span>,
                          icon: "download",
                          action: () => {
                            if (c?.audioUrl) {
                              console.log("tiene audio");
                            }
                          },
                        },
                        {
                          title: "Delete",
                          icon: "trash",
                          action: () => eliminarFraseDeCapitulo(chapterIndexSelected, i),
                        },
                      ]}
                      small
                    />
                  </div>
                </div>
              ))}
            </div>
          </Card>
        </>
      ) : (
        <Card
          title="Translate"
          classTitle="title-blue"
          head={
            <div style={{ display: "flex", alignItems: "center" }} className={cn(styles.nav, "tablet-hide")}>
              {LANGS.map((x, index) => (
                <button
                  className={cn(styles.link, styles.linkFlag, {
                    [styles.active]: x === activeTitleTab,
                  })}
                  onClick={() => setActiveTitleTab(x)}
                  key={index}
                  title={LANG_LABELS[x]}
                  aria-label={LANG_LABELS[x]}
                >
                  <img src={`/images/flags/${x}.svg`} alt="" width={24} height={18} />
                </button>
              ))}
            </div>
          }
        >
          <div style={{ minHeight: "65vh" }} className={styles.sentenceList}>
            {chapter?.sentences?.map((c, i) => {
              return (
                <div
                  key={c?.id || i}
                  ref={(el) => { if (translateRefs) translateRefs.current[i] = el; }}
                  className={styles.sentenceContainer}
                >
                  <div className={styles.sentenceContent}>
                    <textarea
                      className={styles.sentenceTextarea}
                      rows="4"
                      value={c?.translations?.find((t) => t?.lang === activeTitleTab)?.trans || ""}
                      onChange={(e) =>
                        editarTraduccionDeFrase(chapterIndexSelected, i, activeTitleTab, {
                          active: activeTitleTab === "en" ? true : false,
                          lang: activeTitleTab,
                          trans: e.target.value,
                        })
                      }
                    />
                    {c?.videoUrl && (
                      <div className={styles.videoWrapper}>
                        <video controls src={c?.videoUrl} />
                      </div>
                    )}
                  </div>
                  <div
                    className={cn(styles.statusBadge, c?.translations?.find((t) => t?.lang === activeTitleTab)?.active ? styles.verified : styles.notVerified)}
                  >
                    {c?.translations?.find((t) => t?.lang === activeTitleTab)?.active ? "Verified" : "Not Verified"}
                  </div>
                  <div className={styles.actionsBadge}>
                    <Actions
                      className={styles.actions}
                      classActionsHead={styles.actionsHead}
                      items={[
                        {
                          title: "Auto-translate",
                          icon: "check",
                          action: () =>
                            traducirTextoFrase(
                              chapterIndexSelected,
                              i,
                              c?.translations?.find((t) => t?.lang === "en")?.trans,
                              activeTitleTab
                            ),
                        },
                        {
                          title: "Verify Trans",
                          icon: "check-all",
                          action: () =>
                            editarTraduccionDeFrase(chapterIndexSelected, i, activeTitleTab, {
                              active: true,
                              lang: activeTitleTab,
                              trans: c?.translations?.find((t) => t?.lang === activeTitleTab)?.trans,
                            }),
                        },
                        {
                          title: "Upload Video",
                          icon: "upload",
                          action: () => {
                            setSentenceIndexSelected(i);
                            setIsModalUploadVideo(true);
                          },
                        },
                        {
                          title: <span style={{ opacity: c?.videoUrl ? 1 : 0.5 }}>Video</span>,
                          icon: "download",
                          action: () => {
                            if (c?.videoUrl) {
                              console.log("tiene video");
                            }
                          },
                        },
                        {
                          title: <span style={{ opacity: c?.audioUrl ? 1 : 0.5 }}>Audio</span>,
                          icon: "download",
                          action: () => {
                            if (c?.audioUrl) {
                              console.log("tiene audio");
                            }
                          },
                        },
                        {
                          title: "Delete",
                          icon: "trash",
                          action: () => eliminarFraseDeCapitulo(chapterIndexSelected, i),
                        },
                      ]}
                      small
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
      )}
    </>
  );
};

export default React.memo(Translate);
